var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"close",attrs:{"title":"关闭"},on:{"click":_vm.close}},[_c('div',{staticClass:"iconfont icon-guanbi"})]),_c('div',{staticClass:"content"},[_vm._t("content")],2),_c('div',{staticClass:"btnMenu"},[_vm._t("btnMenu")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }